export const ADD_IS_LOADED = 'HOME:ADD_IS_LOADED';
export const ADD_WORKOUTS = 'HOME:ADD_WORKOUTS';
export const ADD_RECOMMENDED_WORKOUTS = 'HOME:ADD_RECOMMENDED_WORKOUTS';
export const ADD_CATEGORY_WORKOUTS = 'HOME:ADD_CATEGORY_WORKOUTS';
export const ADD_ACTIVE_CATEGORY = 'HOME:ADD_ACTIVE_CATEGORY';
export const ADD_QUOTE = 'HOME:ADD_QUOTE';
